<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Søjler</mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        @for (field of value.fields; track field; let i = $index) {
          <dt>{{getTranslation(i).value}}</dt>
          <dd>
            @if (getKey(i).value.startsWith('extra_columns.statistic.')) {
              <span>Statistik: {{getStatistic(i)}}</span>
            }
            @if (getKey(i).value.startsWith('extra_columns.dynamic_field.')) {
              <span>Flettefelt: {{getDynamicField(i)}}</span>
            }
            @if (getKey(i).value.startsWith('extra_columns.recommendation.')) {
              <span>Indstillingstekst</span>
            }
            @if (getKey(i).value.startsWith('extra_columns.co_applicant.')) {
              <span>Medansøger: {{getCoApplicantGroup(i)}}</span>
            }
            ({{getSize(i).value}})
          </dd>
        }
      </dl>
      @if (value.fields.length > 0) {
      <div fxFlex="45">
        <p>Opdater indholdet af en søjle på <em>alle</em> sager. Bør kun bruges, når der ændres i opsætningen af søjler.</p>
        <mat-form-field floatLabel="auto">
          <mat-select placeholder="Vælg søjletype til opdatering">
            <mat-option (click)="selectRefreshColumn('statistic')">Statistik</mat-option>
            <mat-option (click)="selectRefreshColumn('dynamic_field')">Flettefelter</mat-option>
            <mat-option (click)="selectRefreshColumn('recommendation')">Indstillingstekst</mat-option>
            <mat-option (click)="selectRefreshColumn('co_applicant')">Medansøger</mat-option>
          </mat-select>
        </mat-form-field>
        @if (!!selectedRefreshColumn) {
          <button class="ml-3" mat-flat-button (click)="refreshColumn()">Genindlæs data</button>
        }

      </div>
      }
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" class="mb-3">
        <div fxLayout="column" formArrayName="fields" style="width: 100%">
          <p>Her kan du tilføje ekstra søjler til kunden. Den kan herfter tilføjes til en søjlevisning.</p>
          @for (_ of fields.controls; track _; let i = $index) {
            <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-2 mt-2" fxFlex="45"
              [formGroupName]="i">
              <mat-form-field fxFlex="25">
                <mat-label>Titel på søjle</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="translation"
                  />
                <mat-hint>Husk at angive titlen ud fra sproget angivet i board app'en. I.E. <b>{{language}}</b></mat-hint>
                @if (getTranslation(i).hasError('required')) {
                  <mat-error>Skal udfyldes</mat-error>
                }
              </mat-form-field>
              <mat-form-field fxFlex="25">
                <mat-label>Data for søjlen</mat-label>
                <mat-select formControlName="key">
                  <mat-optgroup label="Indstilling">
                    <mat-option value="extra_columns.recommendation.text">Tekst</mat-option>
                  </mat-optgroup>
                  @if (statisticDimensions?.length > 0) {
                    <mat-optgroup label="Statistik">
                      @for (dimension of statisticDimensions; track dimension) {
                        <mat-option
                          [value]="'extra_columns.statistic.' + dimension.uuid">
                          {{dimension.title}}
                        </mat-option>
                      }
                    </mat-optgroup>
                  }
                  @if (dynamicFields?.length > 0) {
                    <mat-optgroup label="Flettefelter">
                      @for (field of dynamicFields; track field) {
                        <mat-option
                          [value]="'extra_columns.dynamic_field.' + field.id">
                          {{field.title}}
                        </mat-option>
                      }
                    </mat-optgroup>
                  }
                  @if (coApplicantGroups?.length > 0) {
                    <mat-optgroup label="Medansøger (organisation)">
                      @for (group of coApplicantGroups; track group) {
                        <mat-option [value]="'extra_columns.co_applicant.' + group + '.company'">{{group}} (organisation)</mat-option>
                      }
                    </mat-optgroup>
                    <mat-optgroup label="Medansøger (kontakt)">
                      @for (group of coApplicantGroups; track group) {
                        <mat-option [value]="'extra_columns.co_applicant.' + group + '.name'">{{group}} (kontakt)</mat-option>
                      }
                    </mat-optgroup>
                  }
                </mat-select>
                @if (getKey(i).hasError('required')) {
                  <mat-error>Skal udfyldes</mat-error>
                }
              </mat-form-field>
              <mat-form-field fxFlex="25">
                <mat-label>Størrelsen på søjlen</mat-label>
                <mat-select formControlName="size">
                  <mat-option value="xxs">XXS</mat-option>
                  <mat-option value="xs">XS</mat-option>
                  <mat-option value="s">S</mat-option>
                  <mat-option value="m">M</mat-option>
                  <mat-option value="l">L</mat-option>
                  <mat-option value="xl">XL</mat-option>
                  <mat-option value="xxl">XXL</mat-option>
                </mat-select>
                @if (getSize(i).hasError('required')) {
                  <mat-error>Skal udfyldes</mat-error>
                }
              </mat-form-field>
              <button
                mat-icon-button
                matTooltip="Slet e-mail"
                (click)="doRemoveField(i)"
                ><mat-icon>delete</mat-icon></button>
              </div>
            }
            <div class="mt-3">
              <button
                mat-stroked-button

                matTooltip="Tilføj e-mail"
                (click)="doAddField()"
              >Tilføj søjle</button>
            </div>
          </div>
        </div>
      </form>
    }
    <mat-action-row>
      @if (form.disabled) {
        <button mat-flat-button (click)="doEdit()">Rediger</button>
      }
      @if (form.enabled) {
        <div>
          <button mat-stroked-button (click)="doCancel()">Fortryd</button>
          <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
        </div>
      }
    </mat-action-row>
  </mat-expansion-panel>
